const fileUrl = ({files}) => files.fileUrl;
const signatureUrl = ({files}) => files.signatureUrl;
const errors = ({files}) => files.errors;

export const selectors = {
    fileUrl,
    signatureUrl,
    errors
};
